/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Calendar_LessInputs */

const en_us2_progress_extra_calendar_less = /** @type {(inputs: Progress_Extra_Calendar_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`less`)
};

const pt_br2_progress_extra_calendar_less = /** @type {(inputs: Progress_Extra_Calendar_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`menos`)
};

const es_419_progress_extra_calendar_less = /** @type {(inputs: Progress_Extra_Calendar_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`menos`)
};

const pt_pt2_progress_extra_calendar_less = /** @type {(inputs: Progress_Extra_Calendar_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`menos`)
};

const fr_fr2_progress_extra_calendar_less = /** @type {(inputs: Progress_Extra_Calendar_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moins`)
};

const de_de2_progress_extra_calendar_less = /** @type {(inputs: Progress_Extra_Calendar_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`weniger`)
};

const it_it2_progress_extra_calendar_less = /** @type {(inputs: Progress_Extra_Calendar_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meno`)
};

/**
* | output |
* | --- |
* | "less" |
*
* @param {Progress_Extra_Calendar_LessInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_calendar_less = /** @type {((inputs?: Progress_Extra_Calendar_LessInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Calendar_LessInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_calendar_less(inputs)
	if (locale === "es-419") return es_419_progress_extra_calendar_less(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_calendar_less(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_calendar_less(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_calendar_less(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_calendar_less(inputs)
	return en_us2_progress_extra_calendar_less(inputs)
});
export { progress_extra_calendar_less as "progress-extra.calendar_less" }